import { AppService, APP_MODE } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { DatasourceOnlineService } from './datasource-online.service';
import { DatasourceOfflineService } from './datasource-offline.service';
import { DatasourceService } from './datasource.service';
import { UnitOfWorkOfflineDao } from '../../daos/unitofwork-offline.dao';

const DatasourceServiceFactory = (appService: AppService, httpClient: HttpClient, apiService: ApiService, unitOfWork: UnitOfWorkOfflineDao) =>
    appService.AppMode == APP_MODE.ONLINE_MODE ? 
    new DatasourceOnlineService(httpClient, apiService) : new DatasourceOfflineService(httpClient, apiService, unitOfWork);

export const DatasourceServiceProvider = { 
    provide: DatasourceService,
    useFactory: DatasourceServiceFactory,
    deps: [AppService, HttpClient, ApiService, UnitOfWorkOfflineDao]
};